import { z } from "zod";

/** ISO-8601 timestamp string (backend serialises `Instant` this way). */
export const zTimestamp = z.string();

/** Spring Data `Page<T>` envelope. */
export function zSpringPage<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    content: z.array(item),
    totalElements: z.number(),
    totalPages: z.number(),
    number: z.number(),
    size: z.number(),
  });
}

/** Endpoints that return a bare array. */
export function zArray<T extends z.ZodTypeAny>(item: T) {
  return z.array(item);
}

/** `{ error }` / `{ message }` problem body from `GlobalExceptionHandler`. */
export const zProblem = z.object({
  error: z.string().optional(),
  message: z.string().optional(),
});
